import React, { useMemo, useCallback } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { AutoSizer } from 'react-virtualized';

import { Logs, View } from '@gogame/components';
import { useNumberFormat } from '@gogame/intl-ts';

import { SmartRuleApprovalPreview } from 'scenes/SmartRules/SmartRuleApprovalPreview';
import { SmartRuleRunResults } from 'scenes/SmartRules/SmartRuleRunResults';
import { SmartRuleStartPreview } from 'scenes/SmartRules/SmartRuleStartPreview';
import {
  STATUS_ERROR,
  STATUS_PENDING_FOR_APPROVAL,
  STATUS_PENDING_FOR_START,
  STATUS_ACTIVE,
  STATUS_INACTIVE,
} from 'scenes/SmartRules/constants';
import { loadSmartRuleResults } from 'scenes/SmartRules/sources/smartRules';

import LogItem from './LogItem';
import { SmartRuleAffectedEntitiesDetails } from './SmartRuleAffectedEntitiesDetails';

const getSmartRuleRunResultByStatus = (status) => {
  switch (status) {
    case STATUS_PENDING_FOR_APPROVAL:
      return SmartRuleApprovalPreview;
    case STATUS_PENDING_FOR_START:
      return SmartRuleStartPreview;
    default:
      return SmartRuleRunResults;
  }
};
export const getColor = (id) => {
  switch (id) {
    case STATUS_INACTIVE:
      return 'inactive';
    case STATUS_ACTIVE:
      return 'success';
    case STATUS_ERROR:
      return 'error';
    case STATUS_PENDING_FOR_START:
    case STATUS_PENDING_FOR_APPROVAL:
      return 'pending';
  }
};
export const ActionsLog = ({
  id,
  data,
  isLoading,
  isUpdating,
  openChildComponent,
  status,
  name,
  fetchNextPage,
  hasNextPage,
}) => {
  const numberFormatter = useNumberFormat();

  const handleClickEntities = useCallback(
    async (log) => {
      const { data: lastRunResultData } = await loadSmartRuleResults({ id });
      if (lastRunResultData?.id === log.id) {
        openChildComponent(getSmartRuleRunResultByStatus(status), {
          id: log.ruleId,
        });
      } else {
        openChildComponent(SmartRuleAffectedEntitiesDetails, {
          data: log,
          subTitle: name,
        });
      }
    },
    [openChildComponent, status, name]
  );

  const flatData = useMemo(() => {
    return (data?.pages || []).reduce(
      (acc, page) => [...acc, ...page.rows],
      []
    );
  }, [data?.pages]);

  const prerenderList = useMemo(() => {
    return flatData.map((log) =>
      LogItem({
        log: log,
        key: log.id,
        numberFormatter: numberFormatter,
        onClickEntities: handleClickEntities,
      })
    );
  }, [flatData, numberFormatter, handleClickEntities]);

  return (
    <View
      loading={isUpdating || isLoading}
      // fetching={fetching}
      style={{ flex: 1, paddingLeft: 24 }}
    >
      <AutoSizer disableWidth>
        {({ height }) => (
          <React.Fragment>
            <InfiniteScroll
              next={fetchNextPage}
              dataLength={flatData.length}
              hasMore={hasNextPage}
              height={height - 10}
            >
              <Logs empty={!flatData.length}>{prerenderList}</Logs>
            </InfiniteScroll>
          </React.Fragment>
        )}
      </AutoSizer>
    </View>
  );
};
